"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewDesignFromDesignGroup = exports.getNumEditableTextLayersInPrintable = void 0;
const EditableTextLayer_1 = require("../../../models/layers/EditableTextLayer");
const layers_1 = require("../../../helpers/HAMMER/layers");
const designs_1 = require("../../../services/designs");
const layers_2 = require("../../../services/layers");
const either_1 = require("../../../types/either");
const getNumEditableTextLayersInPrintable = (printable, activePage) => {
  if (printable.isCompositeDesign) {
    if (activePage === layers_2.CoverageType.RIGHT) {
      return printable.layers.filter(l => (0, EditableTextLayer_1.isEditableTextLayer)(l) && l.id.includes('--SHIFTED')).length;
    } else {
      return printable.layers.filter(l => (0, EditableTextLayer_1.isEditableTextLayer)(l) && !l.id.includes('--SHIFTED')).length;
    }
  } else {
    return printable.layers.filter(EditableTextLayer_1.isEditableTextLayer).length;
  }
};
exports.getNumEditableTextLayersInPrintable = getNumEditableTextLayersInPrintable;
// This helper gets the next design id with one more editable text layer in the design group.
const getNewDesignFromDesignGroup = (designGroup, printableId, template, currentNumEditableTextLayers) => {
  for (const designId of designGroup.designs) {
    const designResult = (0, designs_1.findMatchingOrDefaultDesign)({
      newTemplateDesigns: template.designs,
      designId: designId
    });
    if (designResult.isLeft()) {
      return (0, either_1.left)(designResult.value);
    }
    const layersResult = (0, layers_1.getMatchingLayers)(template.layers, designResult.value.layers);
    if (layersResult.isLeft()) {
      return (0, either_1.left)(new Error(`Could not find matching layers for design id: ${designResult.value.id}`));
    }
    const numEditableTextLayer = layersResult.value.filter(EditableTextLayer_1.isEditableTextLayer).length;
    if (numEditableTextLayer === currentNumEditableTextLayers + 1) {
      return (0, either_1.right)(designResult.value);
    }
  }
  // This means we have the max number of Editable Text Layers
  return (0, either_1.left)(new Error(`Could not add more Editable Text Layers to the current printable: ${printableId}, max is ${currentNumEditableTextLayers}`));
};
exports.getNewDesignFromDesignGroup = getNewDesignFromDesignGroup;